import { ServiceError } from "../../service/Shared";
import { normalizeStage } from "./normalizeStage";

const DEAL_DATES_PATH_PREFIX = normalizeStage("DealDates");

const getDealDateErrorFieldKey = (stageKey: string, fieldKey: string): string =>
  `${normalizeStage(stageKey)}.${normalizeStage(fieldKey)}`;

const getDealDatePathParts = (path: string | undefined): { stageKey: string; fieldKey: string } | null => {
  if (!path) return null;

  const pathParts = path.split(".").filter(Boolean);
  if (pathParts.length < 3) return null;

  const [rootKey, stageKey] = pathParts;
  const fieldKey = pathParts[pathParts.length - 1];

  if (normalizeStage(rootKey) !== DEAL_DATES_PATH_PREFIX) return null;

  return { stageKey, fieldKey };
};

export const getDealDateValidationErrorFieldKeys = (errors: ServiceError[] | undefined): Set<string> =>
  new Set(
    (errors ?? [])
      .map((error) => getDealDatePathParts(error.path))
      .filter((pathParts): pathParts is { stageKey: string; fieldKey: string } => pathParts !== null)
      .map(({ stageKey, fieldKey }) => getDealDateErrorFieldKey(stageKey, fieldKey))
  );

export const hasDealDateValidationError = (errorFieldKeys: Set<string>, stageKey: string, fieldKey: string): boolean =>
  errorFieldKeys.has(getDealDateErrorFieldKey(stageKey, fieldKey));
